/**
 * Centralized Calendly URL fetcher
 * Used by: component-calendly.liquid, multiple-step-form.js, email-confirmation-calendly.js
 */
window.CalendlyUrl = (function () {
  const DISPLAY_PARAMS = "?hide_event_type_details=1&hide_gdpr_banner=1";
  const API_ENDPOINT = "https://qb5j99t2cb.execute-api.us-east-2.amazonaws.com/api/";
  const API_KEY = "0Mqvrrd6mfSdpQwrrUeUY9eeayKdu4nm";

  const URLS = {
    roundRobin: "https://calendly.com/mod-retail-team/des-consult",
    emailClickRoundRobin: "https://calendly.com/mod-retail-team/design-consultation-clone",
    pro: "https://calendly.com/lizr-modularclosets/pro-dc",
    rep: (slug) => `https://calendly.com/${slug}/design-meeting`,
  };

  /**
   * Get the Calendly scheduling URL
   * @param {Object} options
   * @param {string} options.email - User email (required for API call)
   * @param {string} [options.name] - User full name (appended to URL)
   * @param {boolean} [options.isPro=false] - If true, returns pro URL without API call
   * @param {boolean} [options.isEmailClickPage=false] - If true, uses emailClickRoundRobin fallback URL
   * @returns {Promise<string>} The Calendly URL with prefill params
   */
  async function getUrl(options) {
    const { email, name, isPro = false, isEmailClickPage = false } = options || {};

    const fallbackUrl = isEmailClickPage ? URLS.emailClickRoundRobin : URLS.roundRobin;

    // Build prefill params
    const params = new URLSearchParams();
    if (email) params.set("email", email);
    if (name) params.set("name", name);
    const prefillString = params.toString() ? "&" + params.toString().replace(/\+/g, "%20") : "";
    const PARAMS = DISPLAY_PARAMS + prefillString;

    // Pro users get static URL, no API call needed
    if (isPro === true) {
      return URLS.pro + PARAMS;
    }

    // No email = can't call API, use fallback
    if (!email) {
      console.warn("[CalendlyUrl] No email provided, using fallback");
      return fallbackUrl + PARAMS;
    }

    // Call API to get routing type
    try {
      const apiUrl = `${API_ENDPOINT}?email=${encodeURIComponent(email)}`;
      const response = await fetch(apiUrl, {
        headers: { "x-api-key": API_KEY },
      });
      const data = await response.json();

      switch (data.type) {
        case "pro":
          return URLS.pro + PARAMS;
        case "rep":
          return URLS.rep(data.slug) + PARAMS;
        default:
          return fallbackUrl + PARAMS;
      }
    } catch (err) {
      console.error("[CalendlyUrl] API error:", err);
      return fallbackUrl + PARAMS;
    }
  }

  return { getUrl, URLS };
})();
